module.exports = __webpack_public_path__ + "assets/img/logo-samkim.a158c1ab.png";